import { JobInfoRecommend } from './JobRecommend'
import { Setting } from './Setting'

export enum UserRole {
  GUEST = 0,
  MENTEE = 10,
  MENTOR = 20,
  ADMIN = 100,
}

export enum StudentRole {
  NORMAL = 0,
  REGISTER = 1, // 모둠의 결과 등록
  EVALUATOR = 2, // 심사위원
}

export type LoginUser = {
  email: string
  password: string
}

export type User = {
  id: number
  userid: string
  username: string
  email: string
  profileImage: string
  userRole: UserRole
  groupId: number
  groupName: string
  setting: Setting
  recentJobs: string
  isUpdatePassword: boolean // 사용자가 password를 변경했으면 plainPassword는 사용을 안하게됨

  // 추천 팝업창에서 UI의 정보를 가져오는데 임시데이터로 사용
  checked: boolean // 추천팝업에서 직업을 멘티에게 추천할 것인지 선택
  recommendContent: string // 추천팝업에서 직업의 추천정보를 멘티에게 입력. job_recommend.recommend_content 필드에 쓰임
  studentRole: number // 수업에서 학생의 역할
}

// // 사용자 정보의 일부만 가져옴
// export type UserSimple = {
//   id: number
//   email: string
//   userid: string
//   username: string
//   profileImage: string
//   userRole: UserRole
//   groupName: string
// }

// 사용자의 비밀번호를 포함한 모든 정보 (admin에서만 사용)
export type UserAll = {
  id: number
  userid: string
  username: string
  email: string
  password: string
  profileImage: string
  userRole: UserRole
  groupId: number
  enabled: boolean
  setting: string
  recentJobs: string
  plainPassword: string // 사용자를 일괄 추가 할때 사용.
  isUpdatePassword: boolean // 사용자가 password를 변경했으면 plainPassword는 사용을 안하게됨
}

// MenteeMentor에서 Mentee정보를 중심으로 가져옴
export type Mentee = {
  //id: number
  mentee: User
  mentorUserId: number
  menteeInfo: string

  // 추천 팝업창에서 UI의 정보를 가져오는데 임시데이터로 사용
  checked: boolean // 추천팝업에서 직업을 멘티에게 추천할 것인지 선택
  recommendContent: string // 추천팝업에서 직업의 추천정보를 멘티에게 입력. job_recommend.recommend_content 필드에 쓰임
}

// MenteeMentor에서 Mentor정보를 중심으로 가져옴
export type Mentor = {
  //id: number
  mentor: User
  menteeUserId: number
  mentorInfo: string
}

// // MenteeMentor에서 Mentor와 JobInfoRecommend를 중심으로 가져옴
// export type MentorJobRecommend = {
//   mentor: User
//   menteeUserId: number
//   mentorInfo: string
//   jobRecommends: JobInfoRecommend[]
// }
